/**
 * NOTE:
 * We are using `cordovaFetch` instead of basic fetch since we need to be
 * able to hack the `Cookie` header for auth purposes.
 */

import { config } from '../configuration';
import { authenticate } from '../utils/cordova.utils';

const defaultOptions = {
  credentials: `${config.credentialsMode}`,
  mode: 'cors',
  redirect: 'manual',
};

const customHeaders = {
  'X-Pake-Client-Version': 3,
  'X-Pake-Client-Name': 'Tilaaja',
};

/** ***********
 * API HELPERS
 * ************ */

const parseJSON = ({ statusText }) => JSON.parse(statusText);

const handleResponse = response => {
  console.log('Response from API:', response);
  const { status, url, headers } = response;
  const contentType = headers['Content-Type'] || headers['content-type'] || '';
  const isJSON = contentType.indexOf('application/json') !== -1;

  /**
   * NOTE:
   * This is kind of a hack...
   *
   * At the moment we find out if we need to login again by looking at the
   * response url when the server redirects us after session expires.
   *
   * TODO: This should probably just check some status instead...
   */
  if (url.indexOf(config.authUrl) !== -1 || status === 307) {
    (async () => {
      await del('cookies');
    })();
    return authenticate();
  }
  if (status === 200 && isJSON) {
    return parseJSON(response);

    // // } else if (status === 200) {
    // //   return response;
    // } else if(status >= 400 && status < 500) {
    //   handleError('HTTP Client Error ' + status);
    // } else if(status >= 500 && status < 600) {
    //   handleError('HTTP Server Error ' + status);
  }

  console.log('Could not parse response', response);
  throw new Error('API Error');
};

const handleError = err => {
  console.log('-- Fetch Error ---');
  console.log(err);
  throw new Error(`Error in fetch: ${err.message}`);
};

// Stringify only arrays, object etc
const formatBody = data =>
  typeof data === 'string' || typeof data === 'number'
    ? data
    : JSON.stringify(data);

/** ***********
 * API METHODS
 * ************ */

export const get = (endpoint, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  console.log('REQUEST (GET)', url, { ...defaultOptions, ...options });
  const opts = {
    ...defaultOptions,
    headers: customHeaders,
    ...options,
  };
  return window.cordovaFetch(url, opts).then(handleResponse).catch(handleError);
};

export const post = (endpoint, data, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...customHeaders,
    },
    ...options, // put here so that headers can be overwritten
    method: 'POST',
    body: formatBody(data),
  };
  console.log('REQUEST (POST)', url, opts);

  return window.cordovaFetch(url, opts).then(handleResponse).catch(handleError);
};

export const put = (endpoint, data, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...customHeaders,
    },
    ...options, // put here so that headers can be overwritten
    method: 'PUT',
    body: formatBody(data),
  };
  console.log('REQUEST (PUT)', url, opts);

  return window.cordovaFetch(url, opts).then(handleResponse).catch(handleError);
};

export const del = (endpoint, data, options = {}) => {
  const url = `${config.apiUrl}${endpoint}`;
  const opts = {
    ...defaultOptions,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      ...customHeaders,
    },
    ...options, // put here so that headers can be overwritten
    method: 'DELETE',
    body: formatBody(data),
  };
  console.log('REQUEST (DEL)', url, opts);

  return window.cordovaFetch(url, opts).then(handleResponse).catch(handleError);
};
